<template>
  <b-modal
    id="createCollegeAdminModal"
    ref="modal"
    class="modal"
    size="lg"
    centered
  >
    <template v-slot:modal-header>
      <div class="upper">
        <label class="upper-label">College Admins</label>
        <div class="title">Invite College Admin</div>
      </div>
      <button class="close" @click="hide()">×</button>
    </template>

    <form-component>
      <form id="createCollegeAdminForm" novalidate @submit.prevent="onSubmit">
        <div class="row mt-4">
          <div class="col-12 col-sm-6">
            <input-text
              id="firstName"
              v-model="firstName"
              v-validate="'required|max:150|server:FirstName'"
              data-vv-as="first name"
              required
              :maxlength="150"
              :error="errors.first('firstName')"
              type="text"
              name="firstName"
              label="First Name"
            />
          </div>
          <div class="col-12 col-sm-6">
            <input-text
              id="lastName"
              v-model="lastName"
              v-validate="'required|max:150|server:LastName'"
              data-vv-as="last name"
              required
              :max-length="150"
              :error="errors.first('lastName')"
              type="text"
              name="lastName"
              label="Last Name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input-text
              id="email"
              v-model="email"
              v-validate="'required|email|max:254|server:Email'"
              data-vv-as="email"
              required
              :maxlength="254"
              :error="errors.first('email')"
              type="email"
              name="email"
              label="Email"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input-type-ahead
              id="schoolId"
              v-validate="'required|server:SchoolId'"
              data-vv-as="college"
              data-vv-name="schoolId"
              required
              :error="errors.first('schoolId')"
              :list="schools"
              :value="schoolId"
              :searchchange="onSchoolSearch"
              :selected-value="onSchoolSelected"
              placeholder="Select a College..."
              label="College"
              option-value="id"
              option-text="display_name"
            />
          </div>
        </div>
      </form>
    </form-component>

    <template v-slot:modal-footer>
      <button class="btn" type="button" @click="hide">Cancel</button>
      <button
        class="btn btn--primary"
        type="submit"
        form="createCollegeAdminForm"
        :disabled="!dirty || submitting"
        :aria-disabled="!dirty || submitting"
      >
        Send Invitation
      </button>
    </template>
  </b-modal>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import UserClient from '@/api/UserClient';
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
import ServerValidator from '@/helpers/mixins/server-validator';

export default {
  name: 'CreateCollegeAdminModal',

  components: {
    FormComponent,
    InputText,
    InputTypeAhead
  },

  mixins: [ServerValidator],

  data() {
    return {
      adminClient: new AdminClient(this.$http),
      userClient: new UserClient(this.$http),

      schoolTimeout: null,
      schools: [],

      submitting: false,
      firstName: '',
      lastName: '',
      email: '',
      schoolId: null
    };
  },

  computed: {
    dirty() {
      return Object.keys(this.veeValidateFields).some((key) => this.veeValidateFields[key].dirty);
    }
  },

  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },

    async onSchoolSearch(query) {
      if (this.schoolId && !query) {
        return;
      }
      if (this.schoolTimeout) {
        clearTimeout(this.schoolTimeout);
      }

      this.schoolTimeout = setTimeout(async () => {
        this.schools =
          (await this.userClient.getCollegeList(query)).results || [];
        this.schoolId = null;
      }, 300);
    },
    onSchoolSelected(schoolId) {
      this.schoolId = schoolId;
    },

    async onSubmit() {
      this.$serverValidator.clear();

      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }

      this.submitting = true;
      try {
        await this.adminClient.createCollegeAdmin(
          this.firstName,
          this.lastName,
          this.email,
          this.schoolId
        );

        this.$emit('created');
        this.$store.commit('setGlobalAlert', {
          msg: 'College admin invitation sent!'
        });

        this.hide();
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.schoolId = null;
      } catch (e) {
        if (e.status === 400) {
          await this.$serverValidator.validateAll(e.body.errors);
        } else {
          this.$store.commit('setGlobalAlert', {
            msg: 'There was an error inviting the college admin. Please try again!',
            error: true
          });
          this.hide();
        }
      }
      this.submitting = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  .upper {
    display: block;
    position: relative;
    padding-right: 30px;
  }

  label.upper-label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

  .title {
    display: block;
    color: $white;
    font-size: 30px;
    font-weight: 700;
    font-family: $serif;
    line-height: 1;
  }
}
</style>
